import { useCallback } from 'react';
import { useInput, FieldTitle } from 'ra-core';
import { KeyboardDatePicker as DatePicker, TimePicker, KeyboardDateTimePicker as DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DayjsUtils from '@date-io/dayjs';
import { InputHelperText, InputProps, TextInputProps } from 'react-admin';
import { defautlDateFormatString, defautlDateTimeFormatString, defautlTimeFormatString } from '../utils/formatters';
import dayjs from 'dayjs';
import { makeStyles } from '@material-ui/styles';
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

interface DefaultPickerProps extends InputProps<TextInputProps>,
  Omit<TextInputProps,
  | 'helperText'
  | 'onChange'
  | 'onBlur'
  | 'onFocus'
  | 'defaultValue'
  | 'options'
  > {
  options?: any;
  formating?: string;
}

interface PickerProps extends DefaultPickerProps {
  PickerComponent: typeof DatePicker | typeof TimePicker | typeof DateTimePicker;

}

const useStyles = makeStyles({
  root: {
    '& .MuiInput-formControl': {
      marginTop: '20px'
    }

  }
})
const Picker = ({ PickerComponent, ...fieldProps }: PickerProps) => {
  const classes = useStyles()

  const {
    options,
    label,
    source,
    resource,
    helperText,
    className,
    variant = 'filled',
    margin = 'dense',
    providerOptions = {
      utils: DayjsUtils,
      locale: 'es',
    },
    format,
    formating,
    onBlur,
    onChange,
    onFocus,
    parse,
    validate,
    ...rest
  } = fieldProps;

  if (!providerOptions.utils)
    providerOptions.utils = DayjsUtils

  const {
    input,
    isRequired,
    meta,
  } = useInput({
    format,
    onBlur,
    onChange,
    onFocus,
    parse,
    resource,
    source,
    validate,
    ...rest,
  });

  const { touched, submitError, error } = meta;

  const handleChange = useCallback(value => {
    Date.parse(value) ? input.onChange(value.toISOString()) : input.onChange(null);
  }, [input]);


  return (
    <MuiPickersUtilsProvider locale={providerOptions.locale} libInstance={dayjs.utc} utils={DayjsUtils}>
      <PickerComponent
        label={label !== '' &&
          label !== false && (
            <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          )}
        variant={variant}
        margin={margin}
        format={formating}
        error={!!(touched && (error || submitError))}
        helperText={
          <InputHelperText
            touched={touched!}
            error={error || submitError}
            helperText={helperText}
          />
        }
        className={classes.root}
        value={input.value ? new Date(input.value) : null}
        onChange={(date: any) => handleChange(date)}
        onBlur={() => input.onBlur((input.value ? new Date(input.value).toISOString() : null) as unknown as any)}
        {...rest}
        {...options}
      />
    </MuiPickersUtilsProvider>
  )
}

export const DateInput = (props: DefaultPickerProps) => <Picker PickerComponent={DatePicker} formating={defautlDateFormatString} {...props} />
export const TimeInput = (props: DefaultPickerProps) => <Picker PickerComponent={TimePicker} formating={defautlTimeFormatString} {...props} />
export const DateTimeInput = (props: DefaultPickerProps) => <Picker PickerComponent={DateTimePicker} formating={defautlDateTimeFormatString} {...props} />